import React from 'react';
import styled from 'styled-components';
import SkeletonCard from './SkeletonCard';

const StatisticsSkeleton = () => {
    return (
        <Container>
            {/* Overview Cards Grid Skeleton */}
            <Grid>
                {Array.from({ length: 5 }).map((_, i) => (
                    <SkeletonCard key={i} />
                ))}
            </Grid>

            {/* Bottom Row Skeleton */}
            <Row>
                <Column>
                    <LargeCardSkeleton />
                </Column>
                <Column>
                    <LargeCardSkeleton />
                </Column>
                <Column half>
                    <LargeCardSkeleton />
                </Column>
            </Row>
        </Container>
    );
};

export default StatisticsSkeleton;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2rem;
`;

const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 1.5rem;
`;

const Row = styled.div`
    display: flex;
    gap: 1.5rem;
    
    @media (max-width: 1200px) {
        flex-direction: column;
    }
`;

const Column = styled.div.withConfig({
    shouldForwardProp: (prop) => prop !== 'half',
})`
    flex: ${props => (props.half ? '0.5' : '1')};
    display: flex;
    flex-direction: column;
`;

const LargeCardSkeleton = styled.div`
    height: 400px;
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    border: 1px solid #e5e7eb;
    position: relative;
    overflow: hidden;

    &::after {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        transform: translateX(-100%);
        background-image: linear-gradient(
            90deg,
            rgba(255, 255, 255, 0) 0,
            rgba(255, 255, 255, 0.2) 20%,
            rgba(255, 255, 255, 0.5) 60%,
            rgba(255, 255, 255, 0)
        );
        animation: shimmer 2s infinite;
    }

    @keyframes shimmer {
        100% {
            transform: translateX(100%);
        }
    }
`;
